import {DashboardViewActions, DashboardViewActionTypes} from '../actions/dashboard-view.actions';
import {ListPaneType} from '../enums/list-pane-type.enum';

export interface State {
  selectedListPane: ListPaneType;
}

export const initialState: State = {
  selectedListPane: ListPaneType.Grid
};

export function reducer(state = initialState, action: DashboardViewActions): State {
  switch (action.type) {

    case DashboardViewActionTypes.SwitchListPane: {
      const newSelectedListPane: ListPaneType = action.payload;
      return {
        ...state,
        selectedListPane: newSelectedListPane
      };
    }

    default:
      return state;
  }
}

export const selectedListPane = (state: State) => state.selectedListPane;
